export const REQUIRED_MSG = 'This field is required';
export const INCORRECT_VALUE_MSG = 'Incorrect value';
export const ERROR_MESSAGES_MAP: Map<string, string> = new Map()
    .set('required', REQUIRED_MSG)
    .set('email', INCORRECT_VALUE_MSG)
    .set('pattern', INCORRECT_VALUE_MSG);
